


































































import Vue, { PropType } from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Rates from "@/components/Molecules/Rates/index.vue";
import CompanyLogo from "@/components/Atoms/CompanyLogo/index.vue";
import { Data, Methods, Computed, Props } from "./types";
import { numberWithCommas } from "@/helpers/format-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "CompanyCard",
  components: {
    Heading,
    Rates,
    CompanyLogo
  },
  props: {
    company: {
      type: Object as PropType<Props["company"]>,
      required: true
    },
    universityNamesFromQuery: {
      type: Array as PropType<Props["universityNamesFromQuery"]>,
      default: () => []
    },
    showRank: {
      type: Boolean as PropType<Props["showRank"]>,
      default: false
    }
  },
  computed: {
    likedCountText() {
      if (this.universityNamesFromQuery.length === 0) {
        return `${numberWithCommas(
          this.company.like_count
        )}名の学生がお気に入り`;
      } else if (this.universityNamesFromQuery.length === 1) {
        return `${this.universityNamesFromQuery[0]}の${numberWithCommas(
          this.company.like_count_by_university!
        )}名の学生がお気に入り（お気に入り総数：${numberWithCommas(
          this.company.like_count
        )}名）`;
      } else {
        return `${this.universityNamesFromQuery[0]} 他${this
          .universityNamesFromQuery.length - 1}大学の${numberWithCommas(
          this.company.like_count_by_university!
        )}名の学生がお気に入り（お気に入り総数：${numberWithCommas(
          this.company.like_count
        )}名）`;
      }
    },
    experienceCountText() {
      return this.company.report_count
        ? `${numberWithCommas(this.company.report_count)}件`
        : "0件";
    },
    rankDiff() {
      return this.company.previous_rank - this.company.rank;
    },
    diffState() {
      if (this.rankDiff >= 1) return "up";
      else if (this.rankDiff <= -1) return "down";
      return "even";
    },
    iconName() {
      if (this.company.rank === 1) return "Crown-Gold";
      if (this.company.rank === 2) return "Crown-Silver";
      if (this.company.rank === 3) return "Crown-Bronze";
      return "";
    }
  },
  methods: {
    handleClick() {
      this.$emit("click", this.company);
    }
  }
});
